import React from 'react';
import classes from './Button.css';
const Button = (props) => {

    return (
        <button
            className={[classes.Button, props.success ? classes.Success : classes.Danger].join(' ')}
            onClick={props.onClicked}>
            {props.children}
        </button>);
}

export default Button;